import React from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

const inputComponent: React.FC<any> = ({ inputRef, ...props }) => <div ref={inputRef} {...props} />;

const SelectControl: React.FC<any> = ({ children, innerProps, innerRef, selectProps: { classes, TextFieldProps } }) => (
  <TextField
    margin="normal"
    fullWidth
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      ),
      inputComponent,
      inputProps: {
        className: classes.input,
        ref: innerRef,
        children,
        ...innerProps,
      },
    }}
    {...TextFieldProps}
  />
);

export default SelectControl;
